import React, { useEffect, useState } from "react";
import { publicApi } from "../admin/adminApi";
import "./Marquee.css";
export default function Marquee() {
  const [courses, setCourses] = useState([]);
  useEffect(() => {
    let cancelled = false;
    publicApi
      .listCourses()
      .then((data) => {
        if (!cancelled) setCourses(data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
  if (courses.length === 0) return null;
  const track = [...courses, ...courses];
  return (
    <div className="marquee">
      <div className="marquee__track">
        {track.map((course, i) => (
          <span className="marquee__item" key={`${course._id || course.slug}-${i}`}>
            {course.name}
            <span className="marquee__dot">&#9670;</span>
          </span>
        ))}
      </div>
    </div>
  );
}